import React, { useState, useEffect } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = () => {
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMobileMenuOpen(false);
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
    { path: '/admin', icon: '📊', name: 'Dashboard' },
    { path: '/admin/orders', icon: '📦', name: 'Orders' },
    { path: '/admin/products', icon: '👓', name: 'Products' },
    { path: '/admin/categories', icon: '📁', name: 'Categories' },
    { path: '/admin/customers', icon: '👥', name: 'Customers' },
    { path: '/admin/lens-options', icon: '🔍', name: 'Lens Options' },
    { path: '/admin/coupons', icon: '🏷️', name: 'Coupons' },
    { path: '/admin/reviews', icon: '⭐', name: 'Reviews' },
    { path: '/admin/cart', icon: '🛒', name: 'Cart' },
    { path: '/admin/reports', icon: '📈', name: 'Reports' }
  ];

  const toggleSidebar = () => {
    if (isMobile) {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    } else {
      setIsSidebarCollapsed(!isSidebarCollapsed);
    }
  };

  const closeMobileMenu = () => {
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <div className={`admin-layout ${isSidebarCollapsed ? 'collapsed' : ''} ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      {/* Mobile Overlay */}
      {isMobile && isMobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}></div>
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${isMobile ? 'mobile' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-icon">👁️</span>
            {(!isSidebarCollapsed || isMobile) && <span className="logo-text">Admin Panel</span>}
          </div>
          <button 
            className="collapse-btn" 
            onClick={toggleSidebar}
            aria-label={isMobile ? "Close menu" : "Toggle sidebar"}
          >
            {isMobile ? (isMobileMenuOpen ? '✕' : '☰') : (isSidebarCollapsed ? '→' : '←')}
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">{item.icon}</span>
              {(!isSidebarCollapsed || isMobile) && <span className="nav-name">{item.name}</span>}
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <Link to="/" className="back-to-site" onClick={closeMobileMenu}>
            <span className="nav-icon">🏠</span>
            {(!isSidebarCollapsed || isMobile) && <span>Back to Site</span>}
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <div className="admin-header">
          <button 
            className="mobile-menu-toggle" 
            onClick={toggleSidebar}
            aria-label="Toggle menu"
          >
            ☰
          </button>
          <h1>{menuItems.find(item => item.path === location.pathname)?.name || 'Dashboard'}</h1>
          <div className="admin-user">
            <span className="user-name">Admin</span>
            <span className="user-avatar">A</span>
          </div>
        </div>
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;